module.exports = __webpack_public_path__ + "img/ic_zhihu_nor.d1b4589a.svg";